export const selectAllNotifications = state => state.notification.notifications
export const selectRecentNotifications = state => state.notification.recent
export const selectPlayerId = state => state.notification.playerId
export const isNotificationsEnabled = state => state.notification.enabled
export const selectOrderNotificiation = state => state.notification.order
export const selectFieldsNotification = state => state.notification.fields
export const selectUsersByNotification = state => state.notification.users
